export const getAllSalesFunnelsEndpoint = 'sales-funnels';
